import { render, staticRenderFns } from "./MyTable.vue?vue&type=template&id=45f8524f&scoped=true"
import script from "./MyTable.vue?vue&type=script&lang=js"
export * from "./MyTable.vue?vue&type=script&lang=js"
import style0 from "./MyTable.vue?vue&type=style&index=0&id=45f8524f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8524f",
  null
  
)

export default component.exports